var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { loanResponseStatus } from '@repo/shared/types';
import { baseCommon } from './steps-common-data.mock';
export var loanProcessStep1 = __assign(__assign({}, baseCommon), { data: {
        loanId: 1234523,
        status: loanResponseStatus.enum.NEW,
        providerRequest: 'requested',
        stage: 1,
    } });
